__turbopack_context__.v({
  "modal-content": "hotline-modal-content-module__Uxhw6W__modal-content",
  "text": "hotline-modal-content-module__Uxhw6W__text",
});
